const MINI_SITE_PATTERNS = {
  olympiacos: /(?:^|[.-])olympiacos\d*(?:[.-]|$)/i,
  shopflix: /(?:^|[.-])shopflix(?:[.-]|$)/i,
  public: /(?:^|[.-])public(?:[.-]|$)/i,
  in: /(?:^|[.-])in(?:[.-]|$)/i,
  embedded: /(?:^|[.-])embedded(?:[.-]|$)/i,
  paobc: /(?:^|[.-])paobc(?:[.-]|$)/i,
};

const hostname = window.location.hostname;

const useMiniSite = () => ({
  isOlympiacos: MINI_SITE_PATTERNS.olympiacos.test(hostname),
  isShopflix: MINI_SITE_PATTERNS.shopflix.test(hostname),
  isPublic: MINI_SITE_PATTERNS.public.test(hostname),
  isInMinisite: MINI_SITE_PATTERNS.in.test(hostname),
  isEmbedded: MINI_SITE_PATTERNS.embedded.test(hostname),
  isPaoBC: MINI_SITE_PATTERNS.paobc.test(hostname),
});

export default useMiniSite;
